var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('h6',[_vm._v("Pagamento via:")]),_c('img',{attrs:{"src":_vm.gatewayImage.image,"srcset":_vm.gatewayImage.image2x + ' 2x'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }